webpackJsonp([1],Array(66).concat([
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/A7.f570ee0.png";

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/A7S.ba3ec44.png";

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/B36.c1c828e.png";

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/FR516.95296fa.png";

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/M17S.9cbf6cc.png";

/***/ }),
/* 71 */,
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Index__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_About__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Contact__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Contact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Product__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Product___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Product__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Details__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Details___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Details__);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Index',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Index___default.a
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_3__components_About___default.a
  }, {
    path: '/contact',
    name: 'Contact',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Contact___default.a
  }, {
    path: '/product',
    name: 'Product',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Product___default.a
  }, {
    path: '/details',
    name: 'Details',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Details___default.a
  }]
}));

/***/ }),
/* 73 */,
/* 74 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(163)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(99),
  /* template */
  __webpack_require__(204),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(72);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui___default.a);

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a }
});

/***/ }),
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 160 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/101KH003.51de6c3.png";

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/101KH004.849c8cf.png";

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/101KH009.779e7f8.png";

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/101KH013.a76f6aa.png";

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/101KH014.c145c3c.png";

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/101KH016.515f7ee.png";

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/101LC002.9a703cb.png";

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/101LC005.4ad82ba.png";

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/101LC006.6edc7f5.png";

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/101LC007.8d75eea.png";

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/101LC008.3213ffe.png";

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/101LC010.ec7ad8f.png";

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/101LC011.12f0a33.png";

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/101LC012.a2c241e.png";

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/101LC015.16bec25.png";

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/KH-101.ecd9b6f.jpg";

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/KH-101LC.2a7cfe0.jpg";

/***/ }),
/* 187 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABvElEQVQ4jY1TLWxbMRA+EDAy6fmcSAMFAQWFBQUFAwMDBYWFAQMBgQEDAwGRBgoKKvXJnzUVBA4EBAwMFAQUDAwMpvF3UkBBQcFAwAMBGciLlqSvWy0Z3Nl338/ZIjvLgS2F3Shs5mAjDXaye+fZpbALBec+8tyH9MFFyxVcOKSO9Mc1BbuNMHtTWZzlfKdgkYV0uMUoplMFi3p+d6TRfio4V/C4Ap3XCl4/w+zGI/Wag9krBxtp5ET649qu9rFD6lQ18JHnGm0gIpKFdKjg0ufTg22UaAOFXVQyiBx6pJ6ISCPYvoLLXanikDoKPmSXs2zLmzhpKlh4pPelnM8K/n4K0x/XFHar4C8NdpLFSVMDzxQ2U9hXveKeRg4VXCrYrmK6nsRyZxc+nx64wE9l/PhEv4iIR+opuPDgNwW7LqbTMvejHF27NPBSwUIDz/6aBLYVnG8lN00Eu6ui1atcSeO8EWxfXn+Z1hUsHNiq1LXN8GE9fwcbeVgsD+z2X8UbJs/WQA5saeS9KPhdQ/r43wYi4mHRw2Ip61jBhWjk/Ut/nIJdB47XcT2/OxKNHOoV917SwIXpWxct38z9AdV0B3j/oZqaAAAAAElFTkSuQmCC"

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shouhou.b7907d6.png";

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/增白剂.17f7c88.jpg";

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/抗氧剂.eb54d64.jpg";

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/硅硐.815c97c.jpg";

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/粉末丁腈.71b7640.jpg";

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/钛白粉.92dc619.jpg";

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(162)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(100),
  /* template */
  __webpack_require__(203),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-907ed730",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(160)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(201),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-672c228a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(158)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(102),
  /* template */
  __webpack_require__(199),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-50d3dbdd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(159)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(103),
  /* template */
  __webpack_require__(200),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-510f21a6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(161)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(202),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7111980a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sfboxl2"
  }, [_c('div', {
    staticClass: "wfull"
  }, [_c('ul', {
    staticClass: "hotfbox"
  }, [_c('li', {
    staticClass: "sfflli"
  }, [_c('div', {
    staticClass: "hotpic"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化镁A7"
    }
  }, [_c('img', {
    staticClass: "attachment-medium size-medium wp-post-image",
    attrs: {
      "width": "490",
      "height": "820",
      "src": __webpack_require__(66),
      "alt": "landing_2017-02-10t03-41-03-309z",
      "srcset": "../../static/img/A7.png 490w, ../../static/img/A7.png 768w, ../../static/img/A7.png 900w",
      "sizes": "(max-width: 490px) 100vw, 490px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hottitle"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化镁A7"
    }
  }, [_vm._v("氢氧化镁A7")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "hotinfo"
  }, [_c('div', {
    staticClass: "xpm Fl"
  }, [_c('b', {
    staticClass: "Fl"
  }, [_vm._v("关键词：")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "tag"
    }
  }, [_vm._v("阻燃剂")])])])]), _vm._v(" "), _c('li', {
    staticClass: "sfflli"
  }, [_c('div', {
    staticClass: "hotpic"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化镁 A7S"
    }
  }, [_c('img', {
    staticClass: "attachment-medium size-medium wp-post-image",
    attrs: {
      "width": "490",
      "height": "820",
      "src": __webpack_require__(67),
      "alt": "landing_2017-02-10t03-41-03-309z",
      "srcset": "../../static/img/A7S.png 490w, ../../static/img/A7S.png 768w, ../../static/img/A7S.png 900w",
      "sizes": "(max-width: 490px) 100vw, 490px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hottitle"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化镁 A7S"
    }
  }, [_vm._v("氢氧化镁 A7S")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "hotinfo"
  }, [_c('div', {
    staticClass: "xpm Fl"
  }, [_c('b', {
    staticClass: "Fl"
  }, [_vm._v("关键词：")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "tag"
    }
  }, [_vm._v("阻燃剂")])])])]), _vm._v(" "), _c('li', {
    staticClass: "sfflli"
  }, [_c('div', {
    staticClass: "hotpic"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化镁  M17S"
    }
  }, [_c('img', {
    staticClass: "attachment-medium size-medium wp-post-image",
    attrs: {
      "width": "490",
      "height": "820",
      "src": __webpack_require__(70),
      "alt": "landing_2017-02-10t03-41-03-309z",
      "srcset": "../../static/img/M17S.png 490w, ../../static/img/M17S.png 768w, ../../static/img/M17S.png 900w",
      "sizes": "(max-width: 490px) 100vw, 490px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hottitle"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化镁  M17S"
    }
  }, [_vm._v("氢氧化镁  M17S")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "hotinfo"
  }, [_c('div', {
    staticClass: "xpm Fl"
  }, [_c('b', {
    staticClass: "Fl"
  }, [_vm._v("关键词：")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "tag"
    }
  }, [_vm._v("阻燃剂")])])])]), _vm._v(" "), _c('li', {
    staticClass: "sfflli"
  }, [_c('div', {
    staticClass: "hotpic"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "无卤阻燃剂 FR516"
    }
  }, [_c('img', {
    staticClass: "attachment-medium size-medium wp-post-image",
    attrs: {
      "width": "490",
      "height": "820",
      "src": __webpack_require__(69),
      "alt": "landing_2017-02-10t03-41-03-309z",
      "srcset": "../../static/img/FR516.png 490w, ../../static/img/B36.png 768w, ../../static/img/FR516.png 900w",
      "sizes": "(max-width: 490px) 100vw, 490px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hottitle"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "无卤阻燃剂 FR516"
    }
  }, [_vm._v("无卤阻燃剂 FR516")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "hotinfo"
  }, [_c('div', {
    staticClass: "xpm Fl"
  }, [_c('b', {
    staticClass: "Fl"
  }, [_vm._v("关键词：")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "tag"
    }
  }, [_vm._v("阻燃剂")])])])]), _vm._v(" "), _c('li', {
    staticClass: "sfflli"
  }, [_c('div', {
    staticClass: "hotpic"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "抑烟成碳剂 B36"
    }
  }, [_c('img', {
    staticClass: "attachment-medium size-medium wp-post-image",
    attrs: {
      "width": "490",
      "height": "820",
      "src": __webpack_require__(68),
      "alt": "landing_2017-02-10t03-41-03-309z",
      "srcset": "../../static/img/B36.png 490w, ../../static/img/B36.png 768w, ../../static/img/B36.png 900w",
      "sizes": "(max-width: 490px) 100vw, 490px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hottitle"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "抑烟成碳剂 B36"
    }
  }, [_vm._v("抑烟成碳剂 B36")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "hotinfo"
  }, [_c('div', {
    staticClass: "xpm Fl"
  }, [_c('b', {
    staticClass: "Fl"
  }, [_vm._v("关键词：")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "tag"
    }
  }, [_vm._v("阻燃剂")])])])]), _vm._v(" "), _c('li', {
    staticClass: "sfflli"
  }, [_c('div', {
    staticClass: "hotpic"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "KH-101LC"
    }
  }, [_c('img', {
    staticClass: "attachment-medium size-medium wp-post-image",
    attrs: {
      "width": "490",
      "height": "820",
      "src": __webpack_require__(176),
      "alt": "landing_2017-02-10t03-41-03-309z",
      "srcset": "../../static/img/101LC002.png 490w, ../../static/img/101LC001.png 768w, ../../static/img/101LC002.png 900w",
      "sizes": "(max-width: 490px) 100vw, 490px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hottitle"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化铝"
    }
  }, [_vm._v("氢氧化铝")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "hotinfo"
  }, [_c('div', {
    staticClass: "xpm Fl"
  }, [_c('b', {
    staticClass: "Fl"
  }, [_vm._v("关键词：")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "tag"
    }
  }, [_vm._v("阻燃剂")])])])]), _vm._v(" "), _c('li', {
    staticClass: "sfflli"
  }, [_c('div', {
    staticClass: "hotpic"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "KH-101LC"
    }
  }, [_c('img', {
    staticClass: "attachment-medium size-medium wp-post-image",
    attrs: {
      "width": "490",
      "height": "820",
      "src": __webpack_require__(170),
      "alt": "landing_2017-02-10t03-41-03-309z",
      "srcset": "../../static/img/101KH003.png 490w, ../../static/img/101LC001.png 768w, ../../static/img/101KH003.png 900w",
      "sizes": "(max-width: 490px) 100vw, 490px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hottitle"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化铝"
    }
  }, [_vm._v("氢氧化铝")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "hotinfo"
  }, [_c('div', {
    staticClass: "xpm Fl"
  }, [_c('b', {
    staticClass: "Fl"
  }, [_vm._v("关键词：")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "tag"
    }
  }, [_vm._v("阻燃剂")])])])]), _vm._v(" "), _c('li', {
    staticClass: "sfflli"
  }, [_c('div', {
    staticClass: "hotpic"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "KH-101LC"
    }
  }, [_c('img', {
    staticClass: "attachment-medium size-medium wp-post-image",
    attrs: {
      "width": "490",
      "height": "820",
      "src": __webpack_require__(171),
      "alt": "landing_2017-02-10t03-41-03-309z",
      "srcset": "../../static/img/101KH004.png 490w, ../../static/img/101LC001.png 768w, ../../static/img/101KH004.png 900w",
      "sizes": "(max-width: 490px) 100vw, 490px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hottitle"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化铝"
    }
  }, [_vm._v("氢氧化铝")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "hotinfo"
  }, [_c('div', {
    staticClass: "xpm Fl"
  }, [_c('b', {
    staticClass: "Fl"
  }, [_vm._v("关键词：")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "tag"
    }
  }, [_vm._v("阻燃剂")])])])]), _vm._v(" "), _c('li', {
    staticClass: "sfflli"
  }, [_c('div', {
    staticClass: "hotpic"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "KH-101LC"
    }
  }, [_c('img', {
    staticClass: "attachment-medium size-medium wp-post-image",
    attrs: {
      "width": "490",
      "height": "820",
      "src": __webpack_require__(177),
      "alt": "landing_2017-02-10t03-41-03-309z",
      "srcset": "../../static/img/101LC005.png 490w, ../../static/img/101LC001.png 768w, ../../static/img/101LC005.png 900w",
      "sizes": "(max-width: 490px) 100vw, 490px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hottitle"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化铝"
    }
  }, [_vm._v("氢氧化铝")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "hotinfo"
  }, [_c('div', {
    staticClass: "xpm Fl"
  }, [_c('b', {
    staticClass: "Fl"
  }, [_vm._v("关键词：")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "tag"
    }
  }, [_vm._v("阻燃剂")])])])]), _vm._v(" "), _c('li', {
    staticClass: "sfflli"
  }, [_c('div', {
    staticClass: "hotpic"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "KH-101LC"
    }
  }, [_c('img', {
    staticClass: "attachment-medium size-medium wp-post-image",
    attrs: {
      "width": "490",
      "height": "820",
      "src": __webpack_require__(178),
      "alt": "landing_2017-02-10t03-41-03-309z",
      "srcset": "../../static/img/101LC006.png 490w, ../../static/img/101LC001.png 768w, ../../static/img/101LC006.png 900w",
      "sizes": "(max-width: 490px) 100vw, 490px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hottitle"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化铝"
    }
  }, [_vm._v("氢氧化铝")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "hotinfo"
  }, [_c('div', {
    staticClass: "xpm Fl"
  }, [_c('b', {
    staticClass: "Fl"
  }, [_vm._v("关键词：")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "tag"
    }
  }, [_vm._v("阻燃剂")])])])]), _vm._v(" "), _c('li', {
    staticClass: "sfflli"
  }, [_c('div', {
    staticClass: "hotpic"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "KH-101LC"
    }
  }, [_c('img', {
    staticClass: "attachment-medium size-medium wp-post-image",
    attrs: {
      "width": "490",
      "height": "820",
      "src": __webpack_require__(179),
      "alt": "landing_2017-02-10t03-41-03-309z",
      "srcset": "../../static/img/101LC007.png 490w, ../../static/img/101LC001.png 768w, ../../static/img/101LC007.png 900w",
      "sizes": "(max-width: 490px) 100vw, 490px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hottitle"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化铝"
    }
  }, [_vm._v("氢氧化铝")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "hotinfo"
  }, [_c('div', {
    staticClass: "xpm Fl"
  }, [_c('b', {
    staticClass: "Fl"
  }, [_vm._v("关键词：")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "tag"
    }
  }, [_vm._v("阻燃剂")])])])]), _vm._v(" "), _c('li', {
    staticClass: "sfflli"
  }, [_c('div', {
    staticClass: "hotpic"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "KH-101LC"
    }
  }, [_c('img', {
    staticClass: "attachment-medium size-medium wp-post-image",
    attrs: {
      "width": "490",
      "height": "820",
      "src": __webpack_require__(180),
      "alt": "landing_2017-02-10t03-41-03-309z",
      "srcset": "../../static/img/101LC008.png 490w, ../../static/img/101LC001.png 768w, ../../static/img/101LC008.png 900w",
      "sizes": "(max-width: 490px) 100vw, 490px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hottitle"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化铝"
    }
  }, [_vm._v("氢氧化铝")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "hotinfo"
  }, [_c('div', {
    staticClass: "xpm Fl"
  }, [_c('b', {
    staticClass: "Fl"
  }, [_vm._v("关键词：")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "tag"
    }
  }, [_vm._v("阻燃剂")])])])]), _vm._v(" "), _c('li', {
    staticClass: "sfflli"
  }, [_c('div', {
    staticClass: "hotpic"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "KH-101LC"
    }
  }, [_c('img', {
    staticClass: "attachment-medium size-medium wp-post-image",
    attrs: {
      "width": "490",
      "height": "820",
      "src": __webpack_require__(172),
      "alt": "landing_2017-02-10t03-41-03-309z",
      "srcset": "../../static/img/101KH009.png 490w, ../../static/img/101LC001.png 768w, ../../static/img/101KH009.png 900w",
      "sizes": "(max-width: 490px) 100vw, 490px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hottitle"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化铝"
    }
  }, [_vm._v("氢氧化铝")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "hotinfo"
  }, [_c('div', {
    staticClass: "xpm Fl"
  }, [_c('b', {
    staticClass: "Fl"
  }, [_vm._v("关键词：")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "tag"
    }
  }, [_vm._v("阻燃剂")])])])]), _vm._v(" "), _c('li', {
    staticClass: "sfflli"
  }, [_c('div', {
    staticClass: "hotpic"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "KH-101LC"
    }
  }, [_c('img', {
    staticClass: "attachment-medium size-medium wp-post-image",
    attrs: {
      "width": "490",
      "height": "820",
      "src": __webpack_require__(181),
      "alt": "landing_2017-02-10t03-41-03-309z",
      "srcset": "../../static/img/101LC010.png 490w, ../../static/img/101LC001.png 768w, ../../static/img/101LC010.png 900w",
      "sizes": "(max-width: 490px) 100vw, 490px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hottitle"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化铝"
    }
  }, [_vm._v("氢氧化铝")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "hotinfo"
  }, [_c('div', {
    staticClass: "xpm Fl"
  }, [_c('b', {
    staticClass: "Fl"
  }, [_vm._v("关键词：")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "tag"
    }
  }, [_vm._v("阻燃剂")])])])]), _vm._v(" "), _c('li', {
    staticClass: "sfflli"
  }, [_c('div', {
    staticClass: "hotpic"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "KH-101LC"
    }
  }, [_c('img', {
    staticClass: "attachment-medium size-medium wp-post-image",
    attrs: {
      "width": "490",
      "height": "820",
      "src": __webpack_require__(182),
      "alt": "landing_2017-02-10t03-41-03-309z",
      "srcset": "../../static/img/101LC011.png 490w, ../../static/img/101LC001.png 768w, ../../static/img/101LC011.png 900w",
      "sizes": "(max-width: 490px) 100vw, 490px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hottitle"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化铝"
    }
  }, [_vm._v("氢氧化铝")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "hotinfo"
  }, [_c('div', {
    staticClass: "xpm Fl"
  }, [_c('b', {
    staticClass: "Fl"
  }, [_vm._v("关键词：")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "tag"
    }
  }, [_vm._v("阻燃剂")])])])]), _vm._v(" "), _c('li', {
    staticClass: "sfflli"
  }, [_c('div', {
    staticClass: "hotpic"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "KH-101LC"
    }
  }, [_c('img', {
    staticClass: "attachment-medium size-medium wp-post-image",
    attrs: {
      "width": "490",
      "height": "820",
      "src": __webpack_require__(183),
      "alt": "landing_2017-02-10t03-41-03-309z",
      "srcset": "../../static/img/101LC012.png 490w, ../../static/img/101LC001.png 768w, ../../static/img/101LC012.png 900w",
      "sizes": "(max-width: 490px) 100vw, 490px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hottitle"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化铝"
    }
  }, [_vm._v("氢氧化铝")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "hotinfo"
  }, [_c('div', {
    staticClass: "xpm Fl"
  }, [_c('b', {
    staticClass: "Fl"
  }, [_vm._v("关键词：")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "tag"
    }
  }, [_vm._v("阻燃剂")])])])]), _vm._v(" "), _c('li', {
    staticClass: "sfflli"
  }, [_c('div', {
    staticClass: "hotpic"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "KH-101LC"
    }
  }, [_c('img', {
    staticClass: "attachment-medium size-medium wp-post-image",
    attrs: {
      "width": "490",
      "height": "820",
      "src": __webpack_require__(173),
      "alt": "landing_2017-02-10t03-41-03-309z",
      "srcset": "../../static/img/101KH013.png 490w, ../../static/img/101LC001.png 768w, ../../static/img/101KH013.png 900w",
      "sizes": "(max-width: 490px) 100vw, 490px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hottitle"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化铝"
    }
  }, [_vm._v("氢氧化铝")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "hotinfo"
  }, [_c('div', {
    staticClass: "xpm Fl"
  }, [_c('b', {
    staticClass: "Fl"
  }, [_vm._v("关键词：")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "tag"
    }
  }, [_vm._v("阻燃剂")])])])]), _vm._v(" "), _c('li', {
    staticClass: "sfflli"
  }, [_c('div', {
    staticClass: "hotpic"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "KH-101"
    }
  }, [_c('img', {
    staticClass: "attachment-medium size-medium wp-post-image",
    attrs: {
      "width": "490",
      "height": "820",
      "src": __webpack_require__(174),
      "alt": "landing_2017-02-10t03-41-03-309z",
      "srcset": "../../static/img/101KH014.png 490w, ../../static/img/101LC001.png 768w, ../../static/img/101KH014.png 900w",
      "sizes": "(max-width: 490px) 100vw, 490px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hottitle"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化铝"
    }
  }, [_vm._v("氢氧化铝")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "hotinfo"
  }, [_c('div', {
    staticClass: "xpm Fl"
  }, [_c('b', {
    staticClass: "Fl"
  }, [_vm._v("关键词：")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "tag"
    }
  }, [_vm._v("阻燃剂")])])])]), _vm._v(" "), _c('li', {
    staticClass: "sfflli"
  }, [_c('div', {
    staticClass: "hotpic"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "KH-101LC"
    }
  }, [_c('img', {
    staticClass: "attachment-medium size-medium wp-post-image",
    attrs: {
      "width": "490",
      "height": "820",
      "src": __webpack_require__(184),
      "alt": "landing_2017-02-10t03-41-03-309z",
      "srcset": "../../static/img/101LC015.png 490w, ../../static/img/101LC001.png 768w, ../../static/img/101LC015.png 900w",
      "sizes": "(max-width: 490px) 100vw, 490px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hottitle"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化铝"
    }
  }, [_vm._v("氢氧化铝")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "hotinfo"
  }, [_c('div', {
    staticClass: "xpm Fl"
  }, [_c('b', {
    staticClass: "Fl"
  }, [_vm._v("关键词：")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "tag"
    }
  }, [_vm._v("阻燃剂")])])])]), _vm._v(" "), _c('li', {
    staticClass: "sfflli"
  }, [_c('div', {
    staticClass: "hotpic"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "KH-101"
    }
  }, [_c('img', {
    staticClass: "attachment-medium size-medium wp-post-image",
    attrs: {
      "width": "490",
      "height": "820",
      "src": __webpack_require__(175),
      "alt": "landing_2017-02-10t03-41-03-309z",
      "srcset": "../../static/img/101KH016.png 490w, ../../static/img/101LC001.png 768w, ../../static/img/101KH016.png 900w",
      "sizes": "(max-width: 490px) 100vw, 490px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hottitle"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化铝"
    }
  }, [_vm._v("氢氧化铝")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "hotinfo"
  }, [_c('div', {
    staticClass: "xpm Fl"
  }, [_c('b', {
    staticClass: "Fl"
  }, [_vm._v("关键词：")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "tag"
    }
  }, [_vm._v("阻燃剂")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "posts-nav wfull"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])
}]}

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sfboxl2"
  }, [_c('div', {
    staticClass: "wfull"
  }, [_c('ul', {
    staticClass: "hotfbox"
  }, [_c('li', {
    staticClass: "sfflli"
  }, [_c('div', {
    staticClass: "hotpic"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化镁A7"
    }
  }, [_c('img', {
    staticClass: "attachment-medium size-medium wp-post-image",
    attrs: {
      "width": "490",
      "height": "820",
      "src": __webpack_require__(66),
      "alt": "landing_2017-02-10t03-41-03-309z",
      "srcset": "../../static/img/A7.png 490w, ../../static/img/A7.png 768w, ../../static/img/A7.png 900w",
      "sizes": "(max-width: 490px) 100vw, 490px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hottitle"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化镁A7"
    }
  }, [_vm._v("氢氧化镁A7")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "hotinfo"
  }, [_c('div', {
    staticClass: "xpm Fl"
  }, [_c('b', {
    staticClass: "Fl"
  }, [_vm._v("关键词：")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "tag"
    }
  }, [_vm._v("阻燃剂")])])])]), _vm._v(" "), _c('li', {
    staticClass: "sfflli"
  }, [_c('div', {
    staticClass: "hotpic"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化镁 A7S"
    }
  }, [_c('img', {
    staticClass: "attachment-medium size-medium wp-post-image",
    attrs: {
      "width": "490",
      "height": "820",
      "src": __webpack_require__(67),
      "alt": "landing_2017-02-10t03-41-03-309z",
      "srcset": "../../static/img/A7S.png 490w, ../../static/img/A7S.png 768w, ../../static/img/A7S.png 900w",
      "sizes": "(max-width: 490px) 100vw, 490px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hottitle"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化镁 A7S"
    }
  }, [_vm._v("氢氧化镁 A7S")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "hotinfo"
  }, [_c('div', {
    staticClass: "xpm Fl"
  }, [_c('b', {
    staticClass: "Fl"
  }, [_vm._v("关键词：")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "tag"
    }
  }, [_vm._v("阻燃剂")])])])]), _vm._v(" "), _c('li', {
    staticClass: "sfflli"
  }, [_c('div', {
    staticClass: "hotpic"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化镁  M17S"
    }
  }, [_c('img', {
    staticClass: "attachment-medium size-medium wp-post-image",
    attrs: {
      "width": "490",
      "height": "820",
      "src": __webpack_require__(70),
      "alt": "landing_2017-02-10t03-41-03-309z",
      "srcset": "../../static/img/M17S.png 490w, ../../static/img/M17S.png 768w, ../../static/img/M17S.png 900w",
      "sizes": "(max-width: 490px) 100vw, 490px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hottitle"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化镁  M17S"
    }
  }, [_vm._v("氢氧化镁  M17S")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "hotinfo"
  }, [_c('div', {
    staticClass: "xpm Fl"
  }, [_c('b', {
    staticClass: "Fl"
  }, [_vm._v("关键词：")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "tag"
    }
  }, [_vm._v("阻燃剂")])])])]), _vm._v(" "), _c('li', {
    staticClass: "sfflli"
  }, [_c('div', {
    staticClass: "hotpic"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "无卤阻燃剂 FR516"
    }
  }, [_c('img', {
    staticClass: "attachment-medium size-medium wp-post-image",
    attrs: {
      "width": "490",
      "height": "820",
      "src": __webpack_require__(69),
      "alt": "landing_2017-02-10t03-41-03-309z",
      "srcset": "../../static/img/FR516.png 490w, ../../static/img/B36.png 768w, ../../static/img/FR516.png 900w",
      "sizes": "(max-width: 490px) 100vw, 490px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hottitle"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "无卤阻燃剂 FR516"
    }
  }, [_vm._v("无卤阻燃剂 FR516")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "hotinfo"
  }, [_c('div', {
    staticClass: "xpm Fl"
  }, [_c('b', {
    staticClass: "Fl"
  }, [_vm._v("关键词：")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "tag"
    }
  }, [_vm._v("阻燃剂")])])])]), _vm._v(" "), _c('li', {
    staticClass: "sfflli"
  }, [_c('div', {
    staticClass: "hotpic"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "抑烟成碳剂 B36"
    }
  }, [_c('img', {
    staticClass: "attachment-medium size-medium wp-post-image",
    attrs: {
      "width": "490",
      "height": "820",
      "src": __webpack_require__(68),
      "alt": "landing_2017-02-10t03-41-03-309z",
      "srcset": "../../static/img/B36.png 490w, ../../static/img/B36.png 768w, ../../static/img/B36.png 900w",
      "sizes": "(max-width: 490px) 100vw, 490px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hottitle"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "抑烟成碳剂 B36"
    }
  }, [_vm._v("抑烟成碳剂 B36")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "hotinfo"
  }, [_c('div', {
    staticClass: "xpm Fl"
  }, [_c('b', {
    staticClass: "Fl"
  }, [_vm._v("关键词：")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "tag"
    }
  }, [_vm._v("阻燃剂")])])])]), _vm._v(" "), _c('li', {
    staticClass: "sfflli"
  }, [_c('div', {
    staticClass: "hotpic"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化铝 KH-101"
    }
  }, [_c('img', {
    staticClass: "attachment-medium size-medium wp-post-image",
    attrs: {
      "width": "490",
      "height": "820",
      "src": __webpack_require__(185),
      "alt": "landing_2017-02-10t03-41-03-309z",
      "srcset": "../../static/img/KH-101.jpg 490w, ../../static/img/KH-101.jpg 768w, ../../static/img/KH-101.jpg 900w",
      "sizes": "(max-width: 490px) 100vw, 490px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hottitle"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化铝 KH-101"
    }
  }, [_vm._v("氢氧化铝 KH-101")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "hotinfo"
  }, [_c('div', {
    staticClass: "xpm Fl"
  }, [_c('b', {
    staticClass: "Fl"
  }, [_vm._v("关键词：")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "tag"
    }
  }, [_vm._v("阻燃剂")])])])]), _vm._v(" "), _c('li', {
    staticClass: "sfflli"
  }, [_c('div', {
    staticClass: "hotpic"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化铝 KH-101LC"
    }
  }, [_c('img', {
    staticClass: "attachment-medium size-medium wp-post-image",
    attrs: {
      "width": "490",
      "height": "820",
      "src": __webpack_require__(186),
      "alt": "landing_2017-02-10t03-41-03-309z",
      "srcset": "../../static/img/KH-101LC.jpg 490w, ../../static/img/101LC001.png 768w, ../../static/img/KH-101LC.jpg 900w",
      "sizes": "(max-width: 490px) 100vw, 490px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hottitle"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化铝 KH-101LC"
    }
  }, [_vm._v("氢氧化铝 KH-101LC")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "hotinfo"
  }, [_c('div', {
    staticClass: "xpm Fl"
  }, [_c('b', {
    staticClass: "Fl"
  }, [_vm._v("关键词：")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "tag"
    }
  }, [_vm._v("阻燃剂")])])])]), _vm._v(" "), _c('li', {
    staticClass: "sfflli"
  }, [_c('div', {
    staticClass: "hotpic"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "粉末丁腈橡胶"
    }
  }, [_c('img', {
    staticClass: "attachment-medium size-medium wp-post-image",
    attrs: {
      "width": "490",
      "height": "820",
      "src": __webpack_require__(192),
      "alt": "landing_2017-02-10t03-41-03-309z",
      "srcset": "../../static/img/粉末丁腈.jpg 490w, ../../static/img/qing.png 768w, ../../static/img/粉末丁腈.jpg 900w",
      "sizes": "(max-width: 490px) 100vw, 490px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hottitle"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "粉末丁腈橡胶"
    }
  }, [_vm._v("粉末丁腈橡胶")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "hotinfo"
  }, [_c('div', {
    staticClass: "xpm Fl"
  }, [_c('b', {
    staticClass: "Fl"
  }, [_vm._v("关键词：")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "tag"
    }
  }, [_vm._v("丁腈橡胶")])])])]), _vm._v(" "), _c('li', {
    staticClass: "sfflli"
  }, [_c('div', {
    staticClass: "hotpic"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "硅酮"
    }
  }, [_c('img', {
    staticClass: "attachment-medium size-medium wp-post-image",
    attrs: {
      "width": "490",
      "height": "820",
      "src": __webpack_require__(191),
      "alt": "landing_2017-02-10t03-41-03-309z",
      "srcset": "../../static/img/硅硐.jpg 490w, ../../static/img/gui.png 768w, ../../static/img/硅硐.jpg 900w",
      "sizes": "(max-width: 490px) 100vw, 490px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hottitle"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "硅酮"
    }
  }, [_vm._v("硅酮")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "hotinfo"
  }, [_c('div', {
    staticClass: "xpm Fl"
  }, [_c('b', {
    staticClass: "Fl"
  }, [_vm._v("关键词：")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "tag"
    }
  }, [_vm._v("加工剂")])])])]), _vm._v(" "), _c('li', {
    staticClass: "sfflli"
  }, [_c('div', {
    staticClass: "hotpic"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "抗氧剂"
    }
  }, [_c('img', {
    staticClass: "attachment-medium size-medium wp-post-image",
    attrs: {
      "width": "490",
      "height": "820",
      "src": __webpack_require__(190),
      "alt": "landing_2017-02-10t03-41-03-309z",
      "srcset": "../../static/img/抗氧剂.jpg 490w, ../../static/img/yang.png 768w, ../../static/img/抗氧剂.jpg 900w",
      "sizes": "(max-width: 490px) 100vw, 490px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hottitle"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "抗氧剂"
    }
  }, [_vm._v("抗氧剂")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "hotinfo"
  }, [_c('div', {
    staticClass: "xpm Fl"
  }, [_c('b', {
    staticClass: "Fl"
  }, [_vm._v("关键词：")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "tag"
    }
  }, [_vm._v("加工剂")])])])]), _vm._v(" "), _c('li', {
    staticClass: "sfflli"
  }, [_c('div', {
    staticClass: "hotpic"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "增白剂"
    }
  }, [_c('img', {
    staticClass: "attachment-medium size-medium wp-post-image",
    attrs: {
      "width": "490",
      "height": "820",
      "src": __webpack_require__(189),
      "alt": "landing_2017-02-10t03-41-03-309z",
      "srcset": "../../static/img/增白剂.jpg 490w, ../../static/img/bai.png 768w, ../../static/img/增白剂.jpg 900w",
      "sizes": "(max-width: 490px) 100vw, 490px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hottitle"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "增白剂"
    }
  }, [_vm._v("增白剂")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "hotinfo"
  }, [_c('div', {
    staticClass: "xpm Fl"
  }, [_c('b', {
    staticClass: "Fl"
  }, [_vm._v("关键词：")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "tag"
    }
  }, [_vm._v("加工剂")])])])]), _vm._v(" "), _c('li', {
    staticClass: "sfflli"
  }, [_c('div', {
    staticClass: "hotpic"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "钛白粉"
    }
  }, [_c('img', {
    staticClass: "attachment-medium size-medium wp-post-image",
    attrs: {
      "width": "490",
      "height": "820",
      "src": __webpack_require__(193),
      "alt": "landing_2017-02-10t03-41-03-309z",
      "srcset": "../../static/img/钛白粉.jpg 490w, ../../static/img/tai.png 768w, ../../static/img/钛白粉.jpg 900w",
      "sizes": "(max-width: 490px) 100vw, 490px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hottitle"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "KH-101LC"
    }
  }, [_vm._v("钛白粉")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "hotinfo"
  }, [_c('div', {
    staticClass: "xpm Fl"
  }, [_c('b', {
    staticClass: "Fl"
  }, [_vm._v("关键词：")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "tag"
    }
  }, [_vm._v("加工剂")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "posts-nav wfull"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])
}]}

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sfboxl2"
  }, [_c('div', {
    staticClass: "wfull"
  }, [_c('div', {
    staticClass: "hotfbox"
  }, [_c('div', {
    staticClass: "after-sales-wfull-left",
    attrs: {
      "id": "contentbox"
    }
  }, [_c('div', {
    staticClass: "aswl-tech"
  }, [_c('span', [_vm._v("售后服务")])]), _vm._v(" "), _c('div', {
    staticClass: "aswl-tech-cont"
  }, [_c('div', {
    staticClass: "aswl-tech-cont-box"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(188)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "aswl-tech-cont-box-div"
  }, [_c('span', {
    staticClass: "iconfontyyy ydy"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(187),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', [_c('h2', [_vm._v("1对1专属顾问及时回复")]), _vm._v(" "), _c('p', [_vm._v("1对1技术支持")]), _vm._v(" "), _c('p', [_vm._v("强大的服务团队")]), _vm._v(" "), _c('p', [_vm._v("QQ：309816335 ")]), _vm._v(" "), _c('p', [_vm._v("微信：haochihaohe2012 ")]), _vm._v(" "), _c('p', [_vm._v("传真：021-39927292 ")]), _vm._v(" "), _c('p', [_vm._v("邮箱：cxg@qikesh.com‍")]), _vm._v(" "), _c('p', [_vm._v("时间：周一到周五 09：00-18：00(法定节假日除外)")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])
}]}

/***/ }),
/* 202 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sfboxl2"
  }, [_c('div', {
    staticClass: "wfull"
  }, [_c('div', {
    staticClass: "hotfbox"
  }, [_c('div', {
    staticClass: "after-sales-wfull-left1",
    attrs: {
      "id": "contentbox"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "article-right"
  }, [_c('router-link', {
    staticClass: "radios",
    attrs: {
      "to": "/details"
    }
  }, [_vm._v(" > ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "article-right"
  }, [_c('router-link', {
    staticClass: "radios",
    attrs: {
      "to": "/details"
    }
  }, [_vm._v(" > ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "article-right"
  }, [_c('router-link', {
    staticClass: "radios",
    attrs: {
      "to": "/details"
    }
  }, [_vm._v(" > ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tec-page-nav"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "after-sales-wfull-left1-head"
  }, [_c('div', {
    staticClass: "terart"
  }, [_c('p', [_vm._v("产品分类")])]), _vm._v(" "), _c('div', {
    staticClass: "terartboto"
  }, [_vm._v("您所在的位置：产品中心 > "), _c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "category tag"
    }
  }, [_vm._v("产品分类")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-left",
    attrs: {
      "id": "div1"
    }
  }, [_c('span', [_vm._v("阻燃剂")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-center"
  }, [_c('div', {
    staticClass: "artcen-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "artcen-right"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化铝（KH-101、KH-101LC）"
    }
  }, [_vm._v("氢氧化铝（KH-101）")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化铝（KH-101、KH-101LC）"
    }
  }, [_vm._v("氢氧化铝（KH-101LC）")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "氢氧化镁（K-6）"
    }
  }, [_vm._v("氢氧化镁（K-6）")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "三氧化二锑"
    }
  }, [_vm._v("三氧化二锑")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "磷氮系阻燃剂"
    }
  }, [_vm._v("磷氮系阻燃剂")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-left",
    attrs: {
      "id": "div2"
    }
  }, [_c('span', [_vm._v("橡胶")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-center"
  }, [_c('div', {
    staticClass: "artcen-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "artcen-right"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "粉末丁腈橡胶"
    }
  }, [_vm._v("粉末丁腈橡胶")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-left",
    attrs: {
      "id": "div3"
    }
  }, [_c('span', [_vm._v("加工剂")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-center"
  }, [_c('div', {
    staticClass: "artcen-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "artcen-right"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "硅酮"
    }
  }, [_vm._v("硅酮")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "硅油"
    }
  }, [_vm._v("硅油")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "抗氧剂"
    }
  }, [_vm._v("抗氧剂")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "紫外线吸收剂"
    }
  }, [_vm._v("紫外线吸收剂")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "javascript:void",
      "title": "钛白粉"
    }
  }, [_vm._v("钛白粉")])])])])
}]}

/***/ }),
/* 203 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sfboxl2"
  }, [_c('div', {
    staticClass: "wfull"
  }, [_c('div', {
    staticClass: "hotfbox"
  }, [_c('div', {
    staticClass: "after-sales-wfull-left1",
    attrs: {
      "id": "contentbox"
    }
  }, [_c('div', {
    staticClass: "details-head"
  }, [_c('div', {
    staticClass: "details-title"
  }, [_c('p', [_vm._v("公司介绍")])]), _vm._v(" "), _c('div', {
    staticClass: "terartboto"
  }, [_vm._v("您所在的位置：关于我们 > "), _c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "category tag"
    }
  }, [_vm._v("关于企业")]), _vm._v(" > 公司介绍")])]), _vm._v(" "), _c('div', {
    staticClass: "datails-content"
  }, [_c('div', [_c('p', {
    staticStyle: {
      "text-indent": "2em"
    }
  }, [_vm._v("\n奇克（上海）实业有限公司创立于2014年，由专业的销售团队，提供进口化工原料及塑料加工助剂的销售和支持。致力于高性能的塑料改性和特种塑料改性行业。\n本公司先后取得韩国KC公司中国大陆地区电缆料市场代理权和韩国全景化学公司在中国大陆地区代理权等。销售的氢氧化铝、氢氧化镁阻燃剂、粉末丁腈橡胶、硅酮塑料加工助剂等产品在市场领域得到了很好的应用，广泛受到了客户的好评。在新老客户的大力支持下，我们赋予最稳定的产品和优质的服务于客户，相信我们将以最诚挚的服务，优惠的价格，与您共创双赢！\n\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "datails-foot"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])
}]}

/***/ }),
/* 204 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "logobox"
  }, [_c('div', {
    staticClass: "logon wfull"
  }, [_c('div', {
    staticClass: "logo Fl"
  }, [_c('h1', {
    staticClass: "p25 animated fadeIn"
  }, [_c('router-link', {
    staticStyle: {
      "background": "url('../static/img/logo.png')",
      "background-size": "100% 100%",
      "background-repeat": "no-repeat",
      "margin-left": "5px"
    },
    attrs: {
      "to": "/",
      "title": "奇克（上海）实业有限公司"
    }
  }, [_vm._v("\n                                奇克（上海）实业有限公司")])], 1)]), _vm._v(" "), _c('nav', {
    staticClass: "cd-primary-nav"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "cd-navigation"
    }
  }, [_c('li', {
    staticClass: "current"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("网站首页")])], 1), _vm._v(" "), _c('li', {
    staticClass: "cd-navigation-li3"
  }, [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("关于我们")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/product"
    }
  }, [_vm._v("产品中心")])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("售后服务")])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "sfheader"
  }, [
    [_c('el-carousel', {
      attrs: {
        "interval": 5000,
        "arrow": "always"
      }
    }, _vm._l((3), function(item) {
      return _c('el-carousel-item', {
        key: item
      }, [_c('h3', [_c('img', {
        attrs: {
          "src": '../static/img/' + item + '.jpg'
        }
      })])])
    }))]
  ], 2), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('div', {
    staticClass: "posts-nav wfull"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _vm._m(2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-trigger",
    attrs: {
      "href": "#cd-navigation"
    }
  }, [_c('span', [_c('em', {
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                Menu\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "cd-navigation-li3"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void"
    }
  }, [_vm._v("新闻中心")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "dbnavhh wfull"
  }, [_c('div', {
    staticClass: "blngwbd Fl",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('h5', [_vm._v("\n                        主营产品\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "menu-%e5%ba%95%e9%83%a8%e4%ba%8c-container"
  }, [_c('ul', {
    staticClass: "footnav",
    attrs: {
      "id": "menu-%e5%ba%95%e9%83%a8%e4%ba%8c"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:void"
    }
  }, [_vm._v("粉末丁腈橡胶")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void"
    }
  }, [_vm._v("氢氧化铝")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void"
    }
  }, [_vm._v("氢氧化镁")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "blngwbd Fl"
  }, [_c('h5', [_vm._v("\n                        合作伙伴\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "menu-%e5%ba%95%e9%83%a8%e4%b8%89-container"
  }, [_c('ul', {
    staticClass: "footnav",
    attrs: {
      "id": "menu-%e5%ba%95%e9%83%a8%e4%b8%89"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:void"
    }
  }, [_vm._v("韩国KC集团")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void"
    }
  }, [_vm._v("韩国LG化学")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "da14n Fr"
  }, [_c('h5', [_vm._v("\n                        售后支持\n                    ")]), _vm._v(" "), _c('h6', {
    staticClass: "iconfont"
  }, [_vm._v("\n                        微信: 309816335\n                    ")]), _vm._v(" "), _c('h6', {
    staticClass: "iconfont"
  }, [_vm._v("\n                        传真：02139927292\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        周一至周五 9:00-18:00\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    staticClass: "footerDiv"
  }, [_c('div', {
    staticClass: "footer01_end"
  }, [_vm._v("\n                \n                    © 版权所有 奇克（上海）实业有限公司 | "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011402006990"
    }
  }, [_vm._v("沪ICP备17021068号")]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])])
}]}

/***/ })
]),[105]);


// WEBPACK FOOTER //
// static/js/app.4c7e05fa964aba8690e2.js